import { parseApiErrorResponse } from '../utils/parseApiError';

export interface TicketPricingDto {
  baseCost: number;
  underageSurcharge: number;
  totalCost: number;
  isUnderage: boolean;
  userAge: number | null;
  baseCostFormatted: string;
  underageSurchargeFormatted: string;
  totalCostFormatted: string;
}

export interface CreatePaymentSessionRequest {
  Ticket_Number: string;
  Ticket_Representation: string;
  Ticket_Citation: string;
  Ticket_Address: string;
  Ticket_City: string;
  Ticket_County: string;
  Ticket_CourtDate: string;
  Ticket_LicenseType: string;
  Ticket_Zone: string;
  Ticket_Url: string;
  Prosecutor_guid?: string;
  Court_guid?: string;
  Ticket_DriversLicenseNumber?: string;
  Ticket_Gender?: string;
  Ticket_PronounSet?: string;
  Ticket_HasTakenDscInPastYear?: boolean;
  /**
   * Filled from the citation by the parser, never typed. No field on the form: the case page is
   * where they are read and corrected. Without them the preservation demand names "Custodian of
   * Records" instead of the agency that holds the footage.
   */
  Ticket_ArrestingAgency?: string;
  Ticket_AgencyCaseNumber?: string;
  Ticket_LicensePlate?: string;
  /** Ticket scan from step 0 — filed under the case after payment. */
  UserDocument_guid?: string;
}

class TicketApi {
  // Get pricing information with potential underage surcharge
  static async getPricing(productName: string): Promise<TicketPricingDto> {
    const params = new URLSearchParams({ productName });
    const apiHost = process.env.API_HOST?.trim() || window.location.origin;

    const response = await fetch(
      `${apiHost}/api/v1/ticket/pricing?${params.toString()}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      },
    );

    if (response.ok) {
      const pricing: TicketPricingDto = await response.json();
      return pricing;
    } else {
      const message = await parseApiErrorResponse(
        response,
        'Failed to fetch pricing',
      );
      throw new Error(message);
    }
  }

  static async createPaymentSession(
    data: CreatePaymentSessionRequest,
  ): Promise<{ checkout_url: string }> {
    const apiHost = process.env.API_HOST?.trim() || window.location.origin;

    const response = await fetch(`${apiHost}/api/v1/ticket/payment-gateway`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(data),
    });

    if (response.ok) {
      return await response.json();
    }

    const message = await parseApiErrorResponse(
      response,
      'Failed to start payment',
    );
    throw new Error(message);
  }
}

export default TicketApi;
